import { purposeValEnhancer } from "../../utils";
import { Axios } from "../axios";
import RecipientDetailsPageProps from "./recipientDetails";

// const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

export const sendRecipients = async (body: RecipientDetailsPageProps.SendRecipeintProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  return await Axios.post(`/remit/user/${vendorUserKey}/recipients`, body, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const deleteRecipient = async (recipientId: any) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  return await Axios.delete(`/remit/user/${vendorUserKey}/recipients/${recipientId}`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const validateRecipient = async (type: string, number: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.get(`/remit/user/validateRecipient?typeOfAccount=${type}&number=${number}`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const getRecipientProfile = async (recipientID: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const userKey = localStorage.getItem("vendorUserKey") || "";
  return await Axios.get(`/remit/user/${userKey}/recipients/${recipientID}`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const getValidCategoryList = async (purposeCodeValue: string, currency: string) => {
  const currentUser = localStorage.getItem("userKey") || "";
  const userAuthId = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (!currentUser) {
    throw new Error("User key not found in local storage");
  }
  return await Axios.get(
    `remit/user/${currentUser}/validRecipientsType`,
    {
      params: {
        purposeCode: purposeValEnhancer(purposeCodeValue),
        currency: currency,
      },
      headers: {
        Authorization: `${userAuthId.idToken}`,
      },
    }
  );
};
